import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1b6c2485")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")

  return (_openBlock(), _createBlock(_component_el_scrollbar, {
    ref: "scrollContainerRef",
    vertical: false,
    class: "scroll-container",
    onWheel: _withModifiers(_ctx.handleScroll, ["prevent"])
  }, {
    default: _withId(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["onWheel"]))
})